export const requestCategories = {
  CPMS: 'CPMS',
  Incident: 'Incident',
};
